module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesElegant@2x.f1b232c.webp";